/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import * as Colors from 'material-ui/styles/colors';
import InlineButton from 'shared/components/InlineButton';
import $ from 'jquery';
import _ from 'lodash';
import CheckIcon from 'material-ui/svg-icons/navigation/check';

const styles = {
  dialogBody: {
    padding: 0,
    fontSize: 16,
    color: Colors.grey600,
    width: 870,
    maxWidth: 870,
  },
  dialogContent: {
    width: 870,
    maxWidth: 870,
  },
  dialogHeader: {
    fontSize: 24,
    backgroundColor: Colors.blue700,
    color: 'white',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  dialogFooter: {
    width: '100%',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  infoBoxIcon: {
    fontSize: 30,
    marginLeft: 15,
    marginRight: 20,
  },
  reportErrorButton: {
    margin: 20
  },
  reportErrorButtonLabel: {
    color: 'black'
  },
  actionButton: {
    margin: 20,
  },
  textFieldContainer: {
    margin: '20px 30px',
    display: 'flex',
    flexDirection: 'column',
  },
  closeIcon: {
    color: 'white'
  }
};

const INITIAL_STATE = {
  apiKey: '',
  apiKeyError: null,
  apiKeyValid: false,
};

@connect(state => ({
  supportEcomdash: state.general.supportLinks.supportEcomdash
}))
export default class EcomdashKeyDialog extends Component {
  state = INITIAL_STATE;
  componentDidUpdate(prevProps, prevState) {
    if (!_.get(prevProps, 'open') && this.props.open) {
      this.setState(INITIAL_STATE); //
      _.defer(() => this.refs.apiKey.focus());
    }
    if (prevState === null || this.state.apiKey !== prevState.apiKey) {
      this.checkApiKey();
    }
    if (this.state.apiKey !== prevState.apiKey) {
      this.clearApiKeyStatus();
    }
  }

  onChange = (event) => {
    this.setState({apiKey: event.target.value});
  };

  saveApiKey = (testOnly = false) => {
    let {apiKey} = this.state;
    apiKey = _.trim(apiKey);
    if (_.isEmpty(apiKey)) {
      return;
    }
    const {templateTagSetId, onClose} = this.props;
    $.ajax({
      method: 'POST',
      url: '/application/account-page/set-ecomdash-key',
      data: {
        apiKey,
        testOnly,
        templateTagSetId
      },
    }).fail((result) => {
      this.setState({
        apiKeyValid: false,
        apiKeyError: result.responseJSON.message,
      });
    }).then((result) => {
      if (result.success) {
        if (testOnly) {
          this.setState({
            apiKeyValid: true,
            apiKeyError: null,
          });
        } else {
          onClose(true);
        }
      } else {
        this.setState({
          apiKeyValid: false,
          apiKeyError: result.message,
        });
      }
    });
  };

  clearApiKeyStatus() {
    this.setState({
      apiKeyValid: false,
      apiKeyError: null,
    });
  }

  checkApiKey = _.debounce(() => this.saveApiKey(true), 1000, {leading: true, trailing: true});

  handleCancel = () => {
    const {onClose} = this.props;
    onClose(false);
  };

  render() {
    const {apiKey, apiKeyError, apiKeyValid} = this.state;
    const {supportEcomdash} = this.props;
    return (
      <Dialog
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        open={this.props.open}
      >
        <div style={styles.dialogHeader}>
          <FontIcon style={styles.infoBoxIcon} color={'white'} className="material-icons">info</FontIcon>
          An API key is required to save your templates on Ecomdash
          <span style={{flexGrow: 1}}/>
          <IconButton
            onClick={this.handleCancel}
            iconStyle={styles.closeIcon}
          >
            <FontIcon className="material-icons">close</FontIcon>
          </IconButton>
        </div>
        <div style={styles.textFieldContainer}>
          <div>
            Follow <InlineButton target="_blank" href={supportEcomdash}>these instructions</InlineButton> to obtain your Ecomdash API key
          </div>
          <div>
            <TextField
              value = {apiKey}
              errorText = {apiKeyError}
              style={{width: 300, marginLeft: 20, marginRight: 20}}
              errorStyle = {{float: 'left'}}
              floatingLabelText="API Key"
              floatingLabelFixed
              hintText="Paste your Ecomdash API key here"
              ref="apiKey"
              onChange={this.onChange}
            />
            <CheckIcon
              style = {{
                verticalAlign: 'text-bottom',
                opacity: apiKeyValid ? 1 : 0,
              }}
              color = {Colors.lightGreen700}
            />
          </div>
        </div>
        <div
          style={styles.dialogFooter}>
          <FlatButton
            style={styles.reportErrorButton}
            labelStyle={styles.reportErrorButtonLabel}
            label="cancel"
            onClick={this.handleCancel}
          />
          <RaisedButton
            primary
            disabled = {!apiKeyValid}
            style={styles.actionButton}
            label="save"
            onClick={() => this.saveApiKey()}
          />
        </div>
      </Dialog>
    );
  }
}

EcomdashKeyDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  templateTagSetId: PropTypes.number.isRequired,
};

EcomdashKeyDialog.defaultProps = {
  open: false,
};